import styled from '@emotion/styled'

// Lumen's `outlined` Card paints a white surface, so the border lives on a wrapper around the `subtle` Card
// (which carries the neutral-subtle surface). Tokens mirror what Lumen's outlined variant uses.
export const CardWrapper = styled.div`
  border: var(--lumen-border-width-xs) solid var(--lumen-color-border-neutral-soft);
  border-radius: var(--lumen-border-radius-16);
  background-color: var(--lumen-color-surface-neutral-subtle-default);
  overflow: hidden;
`

export const TitleWrapper = styled.div`
  max-width: 440px;
`
